import React from 'react';
import { useNavigate } from 'react-router-dom';
import emblem from '../asstes/emblem.svg';
import maharashtraLogo from '../asstes/Maharashtra.svg.png';
import sangliZPLogo from '../asstes/sanglizp.png';
import { useLanguage } from '../context/LanguageContext';

const Websitemnrega = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  // Maharashtra Government color scheme
  const colors = {
    primary: '#003366',
    secondary: '#FF9933',
    accent: '#138808',
    lightBlue: '#E6F0FF',
    cream: '#FFF5E6',
    white: '#FFFFFF',
    darkBlue: '#001A33',
    orange: '#FF8C1A',
    green: '#1A9A4A',
  };

  // Content card gradient
  const contentGradient = {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 50%, #ffffff 100%)',
    boxShadow: '0 4px 15px rgba(0, 51, 102, 0.1)',
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div style={{ background: '#f6f3ee' }} className="text-gray-800 py-6">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate('/')}
                className="text-gray-800 hover:text-gray-600 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <h1 className="text-2xl font-bold">{language === 'marathi' ? 'मनरेगा' : 'MGNREGA'}</h1>
            </div>
            <div className="flex items-center space-x-2">
              <img src={emblem} alt="Emblem" className="w-12 h-12" />
              <img src={maharashtraLogo} alt="Maharashtra" className="w-12 h-12" />
              <img src={sangliZPLogo} alt="Sangli ZP" className="w-12 h-12" />
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div style={contentGradient} className="rounded-lg p-8">
          <h2 className="text-3xl font-bold text-center mb-8" style={{ color: colors.primary }}>
            {language === 'marathi' ? 'महात्मा गांधी राष्ट्रीय ग्रामीण रोजगार हमी योजना (मनरेगा)' : 'Mahatma Gandhi National Rural Employment Guarantee Act (MGNREGA)'}
          </h2>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-lg">
              {language === 'marathi' 
                ? 'महात्मा गांधी राष्ट्रीय ग्रामीण रोजगार हमी योजना ही भारत सरकारची एक महत्त्वाची सामाजिक-आर्थिक योजना आहे. या योजनेची सुरुवात २००५ साली झाली. ग्रामीण भागातील बेरोजगारी कमी करणे व लोकांना रोजगाराची हमी देणे हा या योजनेचा मुख्य उद्देश आहे.'
                : 'The Mahatma Gandhi National Rural Employment Guarantee Act is an important socio-economic scheme of the Government of India. It was launched in 2005. The main objective of this scheme is to reduce unemployment in rural areas and provide a guarantee of employment to the people.'}
            </p>

            <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
              <h3 className="text-2xl font-bold mb-4" style={{ color: colors.primary }}>
                {language === 'marathi' ? 'मनरेगा योजनेची उद्दिष्टे' : 'Objectives of MGNREGA Scheme'}
              </h3>
              <p className="text-lg">
                {language === 'marathi'
                  ? 'मनरेगा योजनेचा प्रमुख उद्देश ग्रामीण भागातील प्रत्येक कुटुंबाला दरवर्षी किमान १०० दिवसांचा मजुरीवर आधारित रोजगार देणे हा आहे. तसेच ग्रामीण भागाचा विकास करणे, दारिद्र्य कमी करणे आणि लोकांचे स्थलांतर थांबवणे हेही या योजनेचे उद्दिष्ट आहे.'
                  : 'The main objective of the MGNREGA scheme is to provide at least 100 days of wage-based employment every year to each rural household. It also aims to develop rural areas, reduce poverty, and stop migration of people.'}
              </p>
            </div>

            <div className="bg-green-50 p-6 rounded-lg border-l-4 border-green-500">
              <h3 className="text-2xl font-bold mb-4" style={{ color: colors.primary }}>
                {language === 'marathi' ? 'मनरेगा अंतर्गत होणारी कामे' : 'Works under MGNREGA'}
              </h3>
              <p className="mb-4 text-lg">
                {language === 'marathi' ? 'या योजनेअंतर्गत प्रामुख्याने खालील कामे केली जातात:' : 'The following works are mainly carried out under this scheme:'}
              </p>
              <ul className="list-disc list-inside space-y-2 text-lg ml-4">
                {language === 'marathi' ? (
                  <>
                    <li>रस्ते बांधकाम</li>
                    <li>जलसंधारण व पाणी साठवणूक</li>
                    <li>शेततळे व विहिरी खोदणे</li>
                    <li>वृक्षारोपण</li>
                    <li>मृद व जलसंवर्धनाची कामे</li>
                  </>
                ) : (
                  <>
                    <li>Road construction</li>
                    <li>Water conservation and water harvesting</li>
                    <li>Digging farm ponds and wells</li>
                    <li>Tree plantation</li>
                    <li>Soil and water conservation works</li>
                  </>
                )}
              </ul>
              <p className="mt-4 text-lg">
                {language === 'marathi' 
                  ? 'ही सर्व कामे स्थानिक गरजेनुसार ग्रामपंचायतीमार्फत केली जातात.'
                  : 'All these works are carried out by the Gram Panchayat according to local needs.'}
              </p>
            </div>

            <div className="bg-orange-50 p-6 rounded-lg border-l-4 border-orange-500">
              <h3 className="text-2xl font-bold mb-4" style={{ color: colors.primary }}>
                {language === 'marathi' ? 'मनरेगा योजनेचे फायदे' : 'Benefits of MGNREGA Scheme'}
              </h3>
              <p className="text-lg">
                {language === 'marathi'
                  ? 'मनरेगा योजनेमुळे ग्रामीण भागातील लोकांना त्यांच्या गावातच रोजगार उपलब्ध होतो. मजुरांना वेळेवर मजुरी मिळते आणि आर्थिक स्थैर्य प्राप्त होते. महिलांना या योजनेत मोठ्या प्रमाणात सहभाग घेण्याची संधी मिळते, त्यामुळे महिला सक्षमीकरणालाही चालना मिळते.'
                  : 'Due to the MGNREGA scheme, employment is available to rural people in their own villages. Laborers get wages on time and achieve financial stability. Women get a significant opportunity to participate in this scheme, which also boosts women\'s empowerment.'}
              </p>
            </div>

            <div className="bg-purple-50 p-6 rounded-lg border-l-4 border-purple-500">
              <h3 className="text-2xl font-bold mb-4" style={{ color: colors.primary }}>
                {language === 'marathi' ? 'निष्कर्ष' : 'Conclusion'}
              </h3>
              <p className="text-lg">
                {language === 'marathi'
                  ? 'मनरेगा योजना ही ग्रामीण भारताच्या विकासासाठी अत्यंत उपयुक्त योजना आहे. रोजगारनिर्मितीबरोबरच ही योजना गावांचा सर्वांगीण विकास घडवून आणते. त्यामुळे मनरेगा ही योजना गरीब व गरजू लोकांसाठी आधारस्तंभ ठरली आहे.'
                  : 'The MGNREGA scheme is highly beneficial for the development of rural India. Along with employment generation, this scheme brings about overall development of villages. Thus, MGNREGA has become a pillar of support for the poor and needy people.'}
              </p>
            </div>

            <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500 text-center">
              <h3 className="text-2xl font-bold mb-4" style={{ color: colors.primary }}>
                {language === 'marathi' ? 'अधिक माहितीसाठी' : 'For More Information'}
              </h3>
              <p className="text-lg mb-4">
                {language === 'marathi'
                  ? 'मनरेगा योजनेबद्दल अधिक माहिती, अर्ज प्रक्रिया, लाभार्थी यादी आणि इतर तपशीलांसाठी खालील अधिकृत वेबसाइटचा भेट द्या:'
                  : 'For more information about the MGNREGA scheme, application process, beneficiary list, and other details, visit the official website below:'}
              </p>
              <a 
                href="https://nrega.dord.gov.in/MGNREGA_new/Nrega_home.aspx"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                {language === 'marathi' ? 'अधिकृत मनरेगा वेबसाइट' : 'Official MGNREGA Website'}
              </a>
              <p className="text-sm text-gray-600 mt-3">
                https://nrega.dord.gov.in/MGNREGA_new/Nrega_home.aspx
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Websitemnrega;
